import React, { Fragment, Component } from 'react';
import { matchPath, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.m.scss';

import { routes } from '../../routes';
import magic from '../../util/magic';

import NavBar from '../../components/NavBar';
import AdminNavBar from '../../components/NavBar/Admin';
import CertificationsAndTraining from './CertificationsAndTraining';
import CEUs from './CEUs';
import Events from './Events';
import Dashboard from './Dashboard';
import Donate from './Donate';
import EditAccount from './EditAccount';
import Membership from './Membership';
import Payments from './Payments';

import AdminUsers from './Admin/Users';
import CourseRegistrations from './Admin/CourseRegistrations';
import AdminIndividualCEUs from './Admin/CEUs/Individual/index';
import AdminGroupCEUs from './Admin/CEUs/Group/index';
import AdminExperiences from './Admin/Experiences';
import AdminExtensions from './Admin/Extensions';
import AdminMemberships from './Admin/Memberships';
import Sidebar from '../../components/Sidebar';

class Authed extends Component {
  static propTypes = {
    location: PropTypes.object,
    user: PropTypes.object,
  };

  state = {
    collapsed: false,
  };

  render() {
    const { location, user } = this.props;
    const collapsed = !matchPath(location.pathname, { path: routes.dashboard, exact: true });
    const isAdmin = user.role === magic.adminRole;

    return (
      <main className={cn(styles.wrapper, 'container-fluid')}>
        <div className="row">
          <Sidebar user={user} collapsed={collapsed} />
          <div className={cn('mt-3', 'mb-5', 'col', { 'overflow-hidden': !collapsed })}>
            <Switch>
              {isAdmin && <Route path={routes.admin.dashboard} component={AdminNavBar} />}
              <Route path={routes.dashboard} component={NavBar} />
            </Switch>
            <Route exact path={routes.dashboard} component={Dashboard} />
            <Route exact path={routes.donate} component={Donate} />
            <Route path={routes.payments.root} component={Payments} />
            <Route path={routes.editProfile.root} component={EditAccount} />
            <Route path={routes.certificationsAndTraining.root} component={CertificationsAndTraining} />
            <Route path={routes.membership.root} component={Membership} />
            <Route path={routes.ceus.root} component={CEUs} />
            <Route path={routes.events.root} component={Events} />

            {isAdmin && (
              <Switch>
                <Route path={routes.admin.users.root} component={AdminUsers} />
                <Route path={routes.admin.courseRegistrations.root} component={CourseRegistrations} />
                <Route path={routes.admin.individualCeus.root} component={AdminIndividualCEUs} />
                <Route path={routes.admin.groupCeus.root} component={AdminGroupCEUs} />
                <Route path={routes.admin.experiences.root} component={AdminExperiences} />
                <Route path={routes.admin.extensions.root} component={AdminExtensions} />
                <Route path={routes.admin.memberships.root} component={AdminMemberships} />
                <Redirect exact from={routes.admin.dashboard} to={routes.admin.users.root} />
              </Switch>
            )}
          </div>
        </div>
      </main>
    );
  }
}

export default withRouter(Authed);
